/*
* Copyright (C) Regione Lombardia
*/
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@shared/shared.module';
import { PagesGestioneProgettoCreaProgettoComponent } from './crea-progetto/crea-progetto.component';
import { PagesGestioneProgettoDettaglioProgettoComponent } from './dettaglio-progetto/dettaglio-progetto.component';
import { PagesGestioneProgettoRoutingModule } from './gestione-progetto.routing';
import { PagesGestioneProgettoModificaProgettoComponent } from './modifica-progetto/modifica-progetto.component';
import { PagesGestioneProgettoRicercaProgettoComponent } from './ricerca-progetto/ricerca-progetto.component';
import { PagesGestioneProgettoToolkitModule } from './_toolkit/toolkit.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        NgbModule,
        SharedModule,
        PagesGestioneProgettoRoutingModule,
        PagesGestioneProgettoToolkitModule
    ],
    declarations: [
        PagesGestioneProgettoCreaProgettoComponent,
        PagesGestioneProgettoDettaglioProgettoComponent,
        PagesGestioneProgettoModificaProgettoComponent,
        PagesGestioneProgettoRicercaProgettoComponent,
    ],
    exports: [
        PagesGestioneProgettoCreaProgettoComponent,
        PagesGestioneProgettoDettaglioProgettoComponent,
        PagesGestioneProgettoModificaProgettoComponent,
        PagesGestioneProgettoRicercaProgettoComponent,
    ],
})
export class PagesGestioneProgettoModule { }
